export default "__VITE_ASSET__B5fmdZpC__"